// Vuetify 3 theme configuration

export const swayThemes = {
    name: 'sway',
    light: {
        dark: false,
        colors: {
            primary: '#33D3FF',
            'primary-darken-1': '#00B8E6',
            'primary-lighten-1': '#66E0FF',
            secondary: '#6B7280',
            'tertiary-brand': '#F3D9DA',
            dark: '#1F2937',
            success: '#10B981',
            warning: '#F59E0B',
            error: '#EF4444',
            info: '#3B82F6',
            text: '#1F2937',
            accent: '#33D3FF',
            light: '#F9FAFB',
            background: '#F9FAFB',
            surface: '#ffffff',
            'sway-blue': '#33D3FF',
            'sway-orange': '#F59E0B',
            'sway-orange-darken-1': '#D97706',
            border: '#E5E7EB',
            event: '#F59E0B'
        }
    },
    dark: {
        dark: true,
        colors: {
            primary: '#33D3FF',
            'primary-darken-1': '#00B8E6',
            secondary: '#6B7280',
            'tertiary-brand': '#F3D9DA',
            dark: '#111827',
            success: '#10B981',
            warning: '#F59E0B',
            error: '#EF4444',
            info: '#3B82F6',
            text: '#F9FAFB',
            accent: '#33D3FF',
            light: '#374151',
            background: '#111827',
            surface: '#1F2937',
            border: '#374151'
        }
    }
}

export const readyCheckThemes = {
    name: 'readyCheck',
    light: {
        dark: false,
        colors: {
            primary: '#65CDBE',
            secondary: '#4fa1a5',
            'tertiary-brand': '#F3D9DA',
            dark: '#102A43',
            text: '#212121',
            accent: '#E2EAF1',
            light: '#f5f5f5',
            background: '#fafafa',
            surface: '#ffffff',
            border: '#d9d9d9'
        }
    },
    dark: {
        dark: true,
        colors: {
            primary: '#65CDBE',
            secondary: '#2196F3',
            'tertiary-brand': '#F3D9DA',
            dark: '#102A43',
            success: '#83C9A0',
            text: '#5C738A',
            accent: '#E2EAF1',
            light: '#f5f5f5',
            background: '#303030',
            surface: '#424242',
            border: '#d9d9d9'
        }
    }
}
